import React from "react";
import classes from "./SelectRow.css"
import Select from "./Select/Select"

const infoRow = (props) => {

    // Only display element if show prop is true
  if (typeof(props.show) === "boolean") {
    if (props.show === false) {
      return null
    }
  }
  
  const outerClasses = [classes.rowContainer];
  const selectClasses = [classes.dropdown];

  if (props.firstRow === true) {
    outerClasses.push(classes.isFirstRow);
  }
  if (props.reducedWidth === true) {
    selectClasses.push(classes.reducedWidth);
  }
  if (props.increasedPadding === true) {
    selectClasses.push(classes.increasedPadding);
  }
  if (props.ultrawide === true) {
    selectClasses.push(classes.ultrawide);
  }

  return (
    <div className={outerClasses.join(" ")} style={{ marginBottom: "10px" }}>
      <p className={classes.title}>{props.title}</p>
      <Select
        className={selectClasses.join(" ")}
        options={props.options}
        onChange={props.onChange}
        isMulti={props.isMulti}
        isClearable={props.isClearable ?? props.isCleareble}
        value={props.value}
        />
    </div>
  );
};


export default infoRow;
